// src/components/AdminLayout.js
import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import "../../styles/admin.css"; // Ensure your CSS handles flex/grid

function AdminLayout() {
  return (
    <div className="admin-container" style={{ display: "flex", minHeight: "100vh" }}>
      
      {/* Sidebar */}
      <Sidebar />

      {/* Main content area */}
      <div className="admin-main" style={{ flex: 1, display: "flex", flexDirection: "column" }}>
        
        {/* Topbar / Navigation */}
        <Topbar />

        {/* Page content */}
        <div
          className="admin-page-content"
          style={{
            flex: 1,
            padding: "20px",
            backgroundColor: "#f5f5f5",
            overflowY: "auto",
          }}
        >
          {/* Dynamic content rendered by React Router */}
          <Outlet />
        </div>

      </div>
    </div>
  );
}

export default AdminLayout;